module.exports = __webpack_public_path__ + "static/media/Stroke-7.b4456623.eot";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/stroke7/fonts/Stroke-7.eot?f72xkr
// module id = 385
// module chunks = 0